import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { ActivitySaleFormType } from '../form-type';

export default function useRecalculate() {
  const { control, setValue } = useFormContext<ActivitySaleFormType>();
  const [activitySales, otherCost, discount] = useWatch({
    control,
    name: ['activitySales', 'otherCost', 'discount'],
  });

  const data = React.useMemo(() => {
    const subtotal = activitySales.reduce((prev, ac) => {
      const subtotalGuest = ac.activitySaleGuests
        .map((asg) => asg.activitySaleGuestDetails)
        .flat()
        .reduce((prev, asgd) => prev + (asgd?.totalPrice || 0), 0);

      const subtotalAddOns = ac.activitySaleAddOns.reduce(
        (prev, csao) => prev + (csao.price || 0),
        0,
      );
      return prev + subtotalGuest + subtotalAddOns;
    }, 0);

    const totalAddOns = activitySales.reduce((prev, ac) => {
      return (
        prev +
        ac.activitySaleAddOns.reduce(
          (addPrev, csao) => addPrev + (csao.price || 0),
          0,
        )
      );
    }, 0);

    const total = subtotal + (otherCost || 0) - (discount || 0);

    setValue('total', total);

    return {
      subtotal,
      otherCost,
      discount,
      total,
      totalAddOns,
    };
  }, [activitySales, discount, otherCost, setValue]);

  return data;
}
